import { createHttp } from './http';
import { getBaseUrl, IDomainMap } from './baseUrl';

let mockUrl = '';
// mockUrl = 'https://yapi.iquanwai.com/mock/45'

const api = createHttp({
  baseURL: '/'
});

export default api;
